<script setup>
import ACTION_TYPES, {
  getActionTypeFromScore
} from '@/Common/Enum/ActionType.js';

const props = defineProps({
  score: Number
});

const actionType = getActionTypeFromScore(props.score);
</script>

<template>
  <div class="mt-4">
    <p v-if="actionType === ACTION_TYPES.NO_ACTION">
      {{ $t('domain_score.partials.risk_description.no_action_required') }}
    </p>
    <p v-else-if="actionType === ACTION_TYPES.ACTION_RECOMMENDED">
      {{ $t('domain_score.partials.risk_description.action_recommended') }}
    </p>
    <p v-else>
      {{ $t('domain_score.partials.risk_description.action_required') }}
    </p>
  </div>
</template>
